import type { WaveRecord } from "@vida/wave-core";
import { WaveParticipantsList } from "./WaveParticipantsList";

type Props = {
  open: boolean;
  wave: WaveRecord;
  inviteEmail: string;
  inviteError: string | null;
  inviteSuccess: string | null;
  linkCopied: boolean;
  onClose: () => void;
  onInviteEmailChange: (email: string) => void;
  onInvite: () => void;
  onCopyLink: () => void;
};

export function WaveShareDialog({
  open,
  wave,
  inviteEmail,
  inviteError,
  inviteSuccess,
  linkCopied,
  onClose,
  onInviteEmailChange,
  onInvite,
  onCopyLink,
}: Props) {
  if (!open) return null;

  return (
    <div className="wave-share-dialog-backdrop" onClick={onClose} role="presentation">
      <div
        className="wave-share-dialog"
        role="dialog"
        aria-labelledby="wave-share-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="wave-share-dialog-header">
          <div>
            <h2 id="wave-share-title">Condividi wave</h2>
            <p className="muted">{wave.title}</p>
          </div>
          <button type="button" className="wave-share-dialog-close" onClick={onClose} aria-label="Chiudi">
            ✕
          </button>
        </header>

        <div className="wave-share-dialog-body">
          <button type="button" className="link-btn" onClick={onCopyLink}>
            {linkCopied ? "Link copiato ✓" : "Copia link"}
          </button>
          <p className="wave-share-hint muted">
            Chi apre il link e accede viene aggiunto come editor.
          </p>

          <div className="wave-share-invite-row">
            <input
              value={inviteEmail}
              placeholder="Email partecipante"
              onChange={(e) => onInviteEmailChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") onInvite();
              }}
            />
            <button type="button" onClick={onInvite}>
              Invita
            </button>
          </div>
          {inviteError && <p className="invite-feedback error">{inviteError}</p>}
          {inviteSuccess && <p className="invite-feedback success">{inviteSuccess}</p>}

          <WaveParticipantsList participants={wave.participants} ownerSub={wave.ownerSub} />
        </div>
      </div>
    </div>
  );
}
